<template>
  <div v-if="brand" class="brand">
    <section class="brand-hero container" :style="{ 'background-color' : brand.colour }">
      <div class="wrapper">
        <router-link class="brand-hero__return-link" :to="{ name: 'home' }"><img class="brand-hero__arrow" src="@/assets/img/arrow.svg"> Back to homepage</router-link>
        <div class="brand-hero-images">
          <div class="brand-hero-images__logo"><img :src="brand.logoWhiteUrl"></div>
          <div class="brand-hero-images__products"><img :src="brand.productImageUrl" width="900" height="900"></div>
        </div>
      </div>
    </section>
    <section class="brand-intro container">
      <div class="wrapper">
        <h1 class="brand-intro__header">The {{brand.title}} story</h1>
        <div class="brand-intro__description rte" v-html="brand.descriptionOne"></div>
      </div>
    </section>
    <section v-if="brand.ingredients.length != 0" class="brand-ingredients container">
      <div class="wrapper">
        <h2 class="brand-ingredients__header">Naturally created with</h2>
        <ul class="brand-ingredients__list">
          <li v-for="(ingredient, index) in brand.ingredients" :key="index">No {{ ingredient }}</li>
        </ul>
      </div>
    </section>
    <section v-if="brand.bannerImageUrl" class="banner wrapper">
      <img :src="brand.bannerImageUrl">
    </section>
    <section class="brand-descriptions container">
      <div class="wrapper">
        <div class="brand-descriptions__description-two rte" v-html="brand.descriptionTwo"></div>
        <div class="brand-descriptions__description-three rte" v-html="brand.descriptionThree"></div>
      </div>
    </section>

    <Footer :socialLinks="socialLinks" :shops="shops" :brands="brands" :contactDetails="contactDetails" />
  </div>
</template>

<script>
import Footer from '@/components/home/Footer.vue'
import {db} from '@/firebase.js'

export default {
  props: ['passedBrands', 'passedSocialLinks', 'passedShops', 'passedContactDetails'],
  data() {
    return {
      brand: null,
      brands: null,
      socialLinks: null,
      shops: null,
      contactDetails: null
    }
  },
  components: {
    Footer
  },
  created() {
    const brandParam = this.$route.params.brand
    const brandSlug = this.$route.params.brandSlug

    if (!brandParam) {
      db.collection('app').doc('appData').get()
      .then(doc => {
        const data = doc.data()
        this.brands = data.brands
        this.contactDetails = data.contactDetails
        this.shops = data.shops
        this.socialLinks = data.socialLinks
        
        this.brand = this.brands.find(el => {
          return brandSlug == el.slug
        })
        console.log(this.brand.ingredients.length);
        
        
      })
    } else {
      this.brands = this.passedBrands
      this.contactDetails = data.passedContactDetails
      this.shops = data.passedShops
      this.socialLinks = data.passedSocialLinks      
      
      this.brand = this.brands.find(el => {
        return brandSlug == el.slug
      })
      
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/css/helpers-variables.scss";

.brand-hero {
  padding-top: 40px;
  padding-bottom: 40px;
}

.brand-hero__return-link {
  color: white;
}

.brand-hero__arrow {
  height: 1em;
  margin-right: 0.2em;
}

.brand-hero-images {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  @media (min-width: $tablet) {
    justify-content: space-around;
  }
}

.brand-hero-images__logo {
  margin-top: 40px;
  width: 80%;
  @media (min-width: $tablet) {
    width: 48%;
  }
}

.brand-hero-images__products {
  max-width: 500px;
  @media (min-width: $tablet) {
    width: 48%;
  }
}

.brand-intro {
  margin-top: 40px;
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media (min-width: $tablet) {
    margin-top: 80px;
    margin-bottom: 40px;
  }
}

.brand-intro__header {
  font-size: 2.5em;
  font-weight: 600;
  line-height: 1.2;
  margin-bottom: 16px;
  letter-spacing: -1px;
  @media (min-width: $tablet) {
    font-size: 4em;
  }
  @media (min-width: $laptop-s) {
    font-size: 4.4em;
  }
}

.brand-intro__header,
.brand-intro__description {
  width: 100%;
  @media (min-width: $tablet) {
    width: 48%;
  }
}

.brand-ingredients {
  text-transform: uppercase;
  @media (min-width: $tablet) {
    margin-bottom: 40px;
  }
}

.brand-ingredients__header {
  font-size: 1em;
  margin-bottom: 1em;
}

.brand-ingredients__list {
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  margin-bottom: 1em;
  li {
    width: 100%;
    @media (min-width: $tablet) {
      width: calc(100% / 3);
    }
  }
}

.banner {
  img {
    width: 100%;
  }
}

.brand-descriptions {
  .wrapper {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  @media (min-width: $tablet) {
    margin-top: 40px;
  }
}

.brand-descriptions__description-two,
.brand-descriptions__description-three {
  @media (min-width: $tablet) {
    width: 48%;
  }
}

.brand .footer {
  margin-top: 40px;
}
</style>
